import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../services/auth';
import './Auth.css';

const PLAN_LABELS = { free: 'Free', starter: 'Starter', pro: 'Pro' };

export default function Register() {
  const [searchParams] = useSearchParams();
  const rawPlan = (searchParams.get('plan') || 'free').toLowerCase();
  const plan = ['free', 'starter', 'pro'].includes(rawPlan) ? rawPlan : 'free';

  const [form,    setForm]    = useState({ name: '', email: '', password: '', confirm: '' });
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate     = useNavigate();
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) return setError('Passwords do not match');
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      if (plan !== 'free') {
        sessionStorage.setItem('pending_plan', plan);
      }
      setSuccess('Account created! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally { setLoading(false); }
  };
  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-grid" />
        <div className="auth-orb orb1" />
        <div className="auth-orb orb2" />
      </div>
      <div className="auth-card">
        <div className="auth-logo">
          <span className="auth-logo-icon">⬡</span>
          <span className="auth-logo-text">CloudUnify</span>
        </div>
        <h1 className="auth-title">Create account</h1>
        <p className="auth-subtitle">Start managing your multi-cloud deployments</p>
        {plan !== 'free' && (
          <div className="auth-success" style={{ marginBottom: 16 }}>
            You selected the <strong>{PLAN_LABELS[plan]}</strong> plan — you'll be asked to complete payment right after you log in.
          </div>
        )}
        {error   && <div className="auth-error">⚠ {error}</div>}
        {success && <div className="auth-success">✅ {success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full name</label>
            <input className="form-control" type="text" placeholder="Nilesh Kaklij"
              value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Email address</label>
            <input className="form-control" type="email" placeholder="you@example.com"
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input className="form-control" type="password" placeholder="Min 6 characters"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Confirm password</label>
            <input className="form-control" type="password" placeholder="Repeat password"
              value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })} required />
          </div>
          <button className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? <><div className="spinner" style={{width:16,height:16,borderWidth:2}}/>Creating account...</> : 'Create Account →'}
          </button>
        </form>
        <p className="auth-link">
          Already have an account? <Link to="/login">Sign in →</Link>
        </p>
      </div>
    </div>
  );
}
